import { render, staticRenderFns } from "./top-notice.vue?vue&type=template&id=32aed6c4&scoped=true"
import script from "./top-notice.vue?vue&type=script&lang=js"
export * from "./top-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aed6c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32aed6c4')) {
      api.createRecord('32aed6c4', component.options)
    } else {
      api.reload('32aed6c4', component.options)
    }
    module.hot.accept("./top-notice.vue?vue&type=template&id=32aed6c4&scoped=true", function () {
      api.rerender('32aed6c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-notice.vue"
export default component.exports